import React from 'react';
import Select from 'react-select'; // Import Select from react-select
import { donationOptions } from './constants';

const DROPDOWN_STYLE = {
  control: (baseStyles, state) => {
    return {
      ...baseStyles,
      borderWidth: "0px",
      minHeight: "0px",
      boxShadow: "0px",
    };
  },
  menu: (baseStyles, state) => {
    return {
      ...baseStyles,
      marginTop: "0px",
      marginBottom: "0px",
      boxShadow: "0px",
      fontSize: "0.9rem",
    };
  },
  option: (baseStyles, state) => {
    return {
      ...baseStyles,
      backgroundColor: state.isFocused ? "#DEEBFF" : "white",
      color: "inherit",
    };
  },
};


class SoireeChoiceDropdown extends React.Component {
  getOption = (choice) => {
    if (choice) {
      return { value: true, label: "Wine Wall" };
    } else {
      return { value: false, label: "Fund a Need" };
    }
  }

  handleOnChange = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    let selectedValue = false;
    if (selectedOption.value === "WineWall") {
      selectedValue = true;
    }

    console.log(this.props.value);

    if (selectedValue !== this.props.value) {
      this.props.toggleValue();
    }

  }


  render() {
    const {
      value,
      label,
      identifier,
      outerClass,
      isRequired
    } = this.props; // Destructure props

    const choiceOptions = donationOptions;

    return (
      <>
          <div className={outerClass ? outerClass : "col-lg-6"}>
            <div className="form-group">
            <label htmlFor={identifier}>
  {label}
  {isRequired && <span className="required"> *</span>}
</label>

              <Select
                id={identifier}
                defaultValue={this.getOption(value)}
                value={this.getOption(value)}
                className="form-control"
                options={choiceOptions}
                styles={DROPDOWN_STYLE}
                onChange={this.handleOnChange}
              />
            </div>
          </div>

      </>
    );
  }
}

export default SoireeChoiceDropdown;
